'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import SchedulingSystem from './SchedulingSystem';

export default function ContactSection() {
  const contactInfo = [
    {
      icon: 'EnvelopeIcon',
      title: 'Email Us',
      content: 'hello@quirkyumbrella.com',
      link: 'mailto:hello@quirkyumbrella.com',
      description: 'Send us an email anytime!',
    },
    {
      icon: 'PhoneIcon',
      title: 'Call Us',
      content: '+91 9971066552',
      link: 'tel:+919971066552',
      description: 'Monday - Friday: 10:00 AM - 6:00 PM IST',
    },
    {
      icon: 'MapPinIcon',
      title: 'Visit Us',
      content: 'Unit 4401, M3M 65th Avenue',
      link: '#',
      description: 'Sector 65, Gurgaon, India',
    },
    {
      icon: 'ClockIcon',
      title: 'Business Hours',
      content: 'Monday - Friday',
      link: '#',
      description: '10:00 AM - 6:00 PM IST',
    },
  ];

  const socialLinks = [
    { name: 'LinkedIn', icon: 'LinkIcon', href: 'https://linkedin.com/company/quirkyumbrella' },
    { name: 'Twitter', icon: 'XMarkIcon', href: 'https://twitter.com/quirkyumbrella' },
    { name: 'Facebook', icon: 'ShareIcon', href: 'https://facebook.com/quirkyumbrella' },
    { name: 'Instagram', icon: 'CameraIcon', href: 'https://instagram.com/quirkyumbrella' },
  ];

  return (
    <section className="pt-28 pb-10 md:pt-20 md:pb-14 lg:pt-24 lg:pb-20 bg-gradient-to-br from-primary/5 via-secondary/5 to-accent/5 overflow-x-hidden">
      <div className="container mx-auto px-4 sm:px-6 w-full max-w-full">
        {/* Header */}
        <div className="text-center mb-8 md:mb-10 lg:mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/20 backdrop-blur-sm rounded-full mb-6">
            <Icon name="ChatBubbleLeftRightIcon" size={20} className="text-accent" />
            <span className="text-sm font-medium text-foreground">Get in Touch</span>
          </div>
          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-foreground mb-4 md:mb-6">
            Let&apos;s Start a <span className="text-primary">Conversation</span>
          </h1>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto">
            Have a question or want to discuss your project? We&apos;re here to help. Reach out and
            let&apos;s create something amazing together.
          </p>
        </div>

        <div className="max-w-7xl mx-auto w-full">
          <div className="grid lg:grid-cols-2 gap-5 md:gap-6 lg:gap-8 w-full">
            {/* Contact Information */}
            <div className="space-y-6 md:space-y-8 w-full min-w-0 lg:col-span-2">
              <div className="grid md:grid-cols-2 gap-6 md:gap-8">
                <div>
                  <h2 className="text-2xl font-bold text-foreground mb-4">Contact Information</h2>
                  <p className="text-muted-foreground mb-6 md:mb-8">
                    We&apos;re always happy to hear from you. Choose the best way to reach us.
                  </p>
                </div>
                <div className="flex items-center justify-end">
                  <a
                    href="/book-meeting"
                    className="px-8 py-4 bg-primary text-primary-foreground rounded-xl font-bold shadow-lg shadow-primary/20 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex items-center gap-2"
                  >
                    <Icon name="CalendarIcon" size={20} />
                    Schedule a Meeting
                  </a>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-4 md:gap-6">
                {contactInfo.map((info, index) => (
                  <a
                    key={index}
                    href={info.link}
                    className="group flex items-start gap-4 p-4 sm:p-5 md:p-6 bg-card rounded-xl border border-border hover:shadow-warm-lg hover:border-primary/50 transition-all duration-300"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center group-hover:bg-primary transition-smooth">
                      <Icon
                        name={info.icon as any}
                        size={24}
                        className="text-primary group-hover:text-primary-foreground transition-smooth"
                      />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-semibold text-foreground mb-1">{info.title}</h3>
                      <p className="text-foreground font-medium mb-1">{info.content}</p>
                      <p className="text-sm text-muted-foreground">{info.description}</p>
                    </div>
                    <Icon
                      name="ArrowRightIcon"
                      size={20}
                      className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-smooth"
                    />
                  </a>
                ))}
              </div>

              {/* Social Media */}
              {/* <div className="pt-8 border-t border-border">
                <h3 className="text-lg font-semibold text-foreground mb-4">Follow Us</h3>
                <div className="flex flex-wrap gap-3">
                  {socialLinks.map((social, index) => (
                    <a
                      key={index}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 px-4 py-2 bg-muted hover:bg-primary hover:text-primary-foreground rounded-md font-medium transition-smooth press-scale"
                    >
                      <Icon name={social.icon as any} size={18} />
                      <span>{social.name}</span>
                    </a>
                  ))}
                </div>
              </div> */}

              {/* Map View */}
              <div className="pt-6 md:pt-8 border-t border-border">
                <h3 className="text-lg font-semibold text-foreground mb-4">Our Location</h3>
                <div className="relative w-full aspect-video md:h-96 bg-muted rounded-xl overflow-hidden border border-border shadow-inner">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.431289133385!2d77.0673473115456!3d28.40625447567848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d2279f045c783%3A0x415b497b0a70f3f8!2sM3M%2065th%20Avenue!5e0!3m2!1sen!2sin!4v1715682456789!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen={true}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Quirky Umbrella Location"
                    className="grayscale hover:grayscale-0 transition-all duration-500 absolute inset-0"
                  ></iframe>
                  <div className="absolute bottom-4 left-4 right-4 bg-background/90 backdrop-blur-sm p-4 rounded-lg border border-border shadow-lg md:max-w-xs">
                    <p className="font-semibold text-foreground flex items-center gap-2">
                      <Icon name="MapPinIcon" size={16} className="text-primary" />
                      Our Office
                    </p>
                    <p className="text-sm text-muted-foreground mt-1">
                      Unit 4401, M3M 65th Avenue, Sector 65, Gurgaon, India
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
